module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_1.5d3dcb3c.jpg";